/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Oiwa: the carousels (Flickity) mark the cards that are scrolled out of view as hidden from assistive technology
 * (aria-hidden) but leave the links inside them reachable with the Tab key. Take those cards out of the tab order as
 * well, and put them back as soon as they scroll into view or the carousel is removed.
 */
(function () {
  if (!window.MutationObserver || !window.WeakSet || !('inert' in HTMLElement.prototype)) {
    return;
  }

  var managed = new WeakSet();

  var sync = function (element) {
    var parent = element.parentNode;
    var hiddenCell = element.getAttribute('aria-hidden') === 'true' && parent && parent.classList && parent.classList.contains('flickity-slider');

    if (hiddenCell) {
      element.inert = true;
      managed.add(element);
    } else if (managed.has(element)) {
      element.inert = false;
      managed.delete(element);
    }
  };

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      sync(record.target);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

  document.querySelectorAll('.flickity-slider > [aria-hidden="true"]').forEach(sync);
})();

/**
 * Oiwa: the product options app gives its text fields autocomplete="noop". That is not a valid value and fails
 * accessibility checks; "off" is the valid way to say the same thing (no browser suggestions). Nothing visible changes.
 */
(function () {
  if (!window.MutationObserver) {
    return;
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    var fix = function () {
      form.querySelectorAll('input[autocomplete="noop"]').forEach(function (input) {
        input.setAttribute('autocomplete', 'off');
      });
    };

    fix();
    new MutationObserver(fix).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['autocomplete'] });
  });
})();

/**
 * Oiwa: the Google reviews carousel (Swiper) keeps the cards it has scrolled out of view reachable with the Tab key and
 * clipped at the edges. Cards that are mostly out of view leave the tab order and come back as they scroll in.
 */
(function () {
  if (!window.IntersectionObserver || !window.MutationObserver || !('inert' in HTMLElement.prototype)) {
    return;
  }

  var watch = function (swiper) {
    if (swiper.hasAttribute('data-oiwa-inert')) {
      return;
    }
    swiper.setAttribute('data-oiwa-inert', '');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.inert = entry.intersectionRatio < 0.5;
      });
    }, { root: swiper, threshold: [0, 0.5, 1] });
    swiper.querySelectorAll('.swiper-slide').forEach(function (slide) {
      observer.observe(slide);
    });
  };

  var scan = function (root) {
    root.querySelectorAll('.agrs__widget .swiper').forEach(watch);
  };

  document.querySelectorAll('[id*="appio_google_reviews"]').forEach(function (block) {
    scan(block);
    new MutationObserver(function () { scan(block); }).observe(block, { childList: true, subtree: true });
  });
})();
